import { render, staticRenderFns } from "./icons.vue?vue&type=template&id=23cf6c91&scoped=true"
import script from "./icons.vue?vue&type=script&lang=ts"
export * from "./icons.vue?vue&type=script&lang=ts"
import style0 from "./icons.vue?vue&type=style&index=0&id=23cf6c91&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23cf6c91",
  null
  
)

export default component.exports